const drawer = document.querySelector('[data-cart-drawer]');
if (drawer) {
  const openTriggers = document.querySelectorAll('[data-cart-open]');
  const closeTriggers = drawer.querySelectorAll('[data-cart-close]');

  function open() {
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    setTimeout(() => { drawer.hidden = true; document.body.style.overflow = ''; }, 300);
  }

  openTriggers.forEach(t => t.addEventListener('click', open));
  closeTriggers.forEach(t => t.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !drawer.hidden) close(); });

  // AJAX cart updates
  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const countEl = document.querySelector('[data-cart-count]');
    const subtotalEl = document.querySelector('[data-cart-subtotal]');
    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
    await refreshDrawerBody();
  }

  async function refreshDrawerBody() {
    const res = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
    const text = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    const newBody = doc.querySelector('[data-cart-body]');
    const curBody = drawer.querySelector('[data-cart-body]');
    if (newBody && curBody) curBody.replaceWith(newBody);
  }

  function formatMoney(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'nl', {
      style: 'currency', currency
    }).format(cents / 100);
  }

  // Delegate clicks for quantity & remove
  drawer.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    const inc = e.target.closest('[data-qty-increase]');
    const dec = e.target.closest('[data-qty-decrease]');
    if (remove) {
      e.preventDefault();
      await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: remove.dataset.lineKey, quantity: 0 })
      });
      await refreshCart();
    } else if (inc || dec) {
      const key = (inc || dec).dataset.lineKey;
      const row = (inc || dec).closest('.cart-line');
      const display = row.querySelector('[data-qty-display]');
      const current = parseInt(display.textContent, 10);
      const next = inc ? current + 1 : Math.max(0, current - 1);
      await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      });
      await refreshCart();
    }
  });

  // Expose: product-form.js calls this after successful add-to-cart
  window.Sandee = window.Sandee || {};
  window.Sandee.openCart = () => { refreshCart().then(open); };
}
